import { Cancel } from '@mui/icons-material'
import { Button, Stack, Typography } from '@mui/material'
import type { FallbackProps } from 'react-error-boundary'
import { gray, red } from '../muikds/kdsColors'

export function DataFetchErrorWithRetry({ resetErrorBoundary }: FallbackProps) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      padding={3}
      spacing={2}
      sx={{
        flex: 1,
        backgroundColor: gray[0],
      }}
    >
      <Cancel sx={{ fontSize: 80, color: red[6] }} />
      <Typography variant="h6">データの取得に失敗しました</Typography>
      <Typography variant="body1">
        画面をリロードするか、再読み込みボタンを押してください
      </Typography>
      <Button variant="contained" color="primary" onClick={resetErrorBoundary}>
        再読み込み
      </Button>
    </Stack>
  )
}
